export const FETCH_COLLECTION = 'FETCH_COLLECTION'
export const RESET_COLLECTION = 'RESET_COLLECTION'
